import * as yup from 'yup'

export const callPricingSchema = yup
  .object()
  .shape({
    stores: yup
      .array()
      .of(yup.string())
      .min(1, 'Please Select atleast one store.')
      .required('Store is required field'),
    aggregators: yup
      .array()
      .of(yup.string())
      .min(1, 'Please Select atleast one Aggregator.')
      .required('Aggregator is required field'),
  })
  .required()
